<template>
 <ubi-page-container wide-main-content>
   <template v-slot:page-actions>
     <el-button class="inline">
       <downloadexcel :fetch="exporterDiffusionByPortal" type="xls" :name="nomFichierExport">
         {{ $t("portals.report.exportResults") }}
       </downloadexcel>
     </el-button>
   </template>
<!--    entete -->
  <ubi-panel :title="$t('portals.report.title')" size="sm">
    <el-row>
      <el-col :lg="16" :md="12">
        <el-row>
            <el-col :lg="12" class="mb-3">
              <strong>{{ $t("portals.report.quota") }}</strong>
              <p v-if="getNbAnnoncesQuota !== 0 && getNbAnnoncesQuota != null">{{ getNbAnnoncesQuota }} {{
                  $t("portals.report.quotaAds")
                }}</p>
              <p v-else>{{ $t("portals.report.quotaUnlimited") }}</p>
              <ubi-stat-value
                  :value="getNbAnnoncesSelectionnees"
                  :sub-value="getNbAnnoncesMax"
                  :label="$t('portals.report.selectedAds')"
              />
              <h5 class="mt-4">
                <strong>{{ $t("portals.report.selectionMode") }}</strong>
              </h5>
              <p>{{ capitalizeFirstLetter(getModeSelectionAutomatique) }}</p>
            </el-col>
            <el-col :lg="12" class="mb-3">
              <strong>{{ $t("portals.report.lastDiffusion") }}</strong>
              <p v-if="getDateEnd !== ''">{{ convertDate(getDateEnd)}}</p>
              <p><strong>{{ getNbAnnoncesDiffusees }} / {{ getNbAnnoncesTraitees }}</strong> {{ $t("portals.report.adsDiffused") }}</p>
            </el-col>
        </el-row>
      </el-col>
      <el-col :lg="8" :md="12">
        <div class="text-muted" style="text-align: center;">
          <el-image :src="getLogoDiffuseur" v-if="getLogoDiffuseur != null"/>
          <p>{{ getNomDiffuseur }}</p>
        </div>
      </el-col>
    </el-row>
  </ubi-panel>
<!--   filtres -->
     <ApiSearchForm
       :business-domain="businessDomain"
       :route="searchRoute"
       :user-context="searchContext"
       :search-placeholder="$t('general.filters.searchByReference')"
       @search="handleSearchFromApi"
       @reset="handleResetFromApi"
     />

<!--   table -->
   <ubi-panel>
     <PaginationPage  :total="getTotalReportPortal"
                      :currentPage.sync="currentPage"
                      :pageSize.sync="pageSize"
                      @update:currentPage="fetchPage"
                      @update:pageSize="fetchPageSize"
     />
     <el-button type="mini" slot="actions">
       <downloadexcel :fetch="exporterDiffusionByPortal" type="xls" :name="nomFichierExport">{{ $t("portals.report.exportResults") }}</downloadexcel>
     </el-button>
     <el-table
      v-loading="getLoadingReportByPortal"
      :element-loading-text="$t('portals.list.chargementDonnees')"
      :data="currentAnnonces"
     >
      <el-table-column type="expand">
        <template v-slot="{ row: post }">
          <p class="mb-0" v-for="message in post.messages" :key="message.idUniq + message.annonce">
            <ubi-icon name="alert" class="text-warning ml-2" v-if="message.codeInterne === 'WARN'"/>
            <ubi-icon
                name="close"
                class="text-white bg-danger rounded-circle ml-2"
                v-if="message.codeInterne === 'ERROR'"
            />
            <em>{{ message.message }}</em>
          </p>
        </template>
      </el-table-column>
       <el-table-column width="100">
         <template v-slot="{ row: post }">
           <img width="80"
                alt=""
                :src="post.photoPrincipale.url_miniature"
                :srcset="post.photoPrincipale.url_miniature"
                v-if="post.photoPrincipale"
           />
         </template>
       </el-table-column>
       <el-table-column :label="$t('portals.report.columnAd')" width="280" v-if="browserContext.up('lg')">
         <template v-slot="{ row: post }">
           <router-link v-if="!isSubUser" :class="{ 'text-muted': post.status === 'ignored' }"
                        :to="{ name: 'post-view', params: { post: post.id } }">
             {{ post.reference }} - {{ post.titre }}
           </router-link>
           <span v-else>
              {{ post.reference }} - {{ post.titre }}
            </span>
         </template>
       </el-table-column>
       <el-table-column :label="$t('portals.report.columnDateCreation')">
         <template v-slot="{ row: post }">
           {{ formatDate(post.dateCreation)}}
         </template>
       </el-table-column>
       <el-table-column :label="$t('portals.report.columnDateModification')">
         <template v-slot="{ row: post }">
           {{formatDate(post.dateModification)}}
         </template>
       </el-table-column>
       <el-table-column :label="$t('portals.report.columnPictures')" width="120">
         <template v-slot="{ row: post }">
           {{ post.photos.length }}
         </template>
       </el-table-column>
     </el-table>
     <PaginationPage  :total="getTotalReportPortal"
                      :currentPage.sync="currentPage"
                      :pageSize.sync="pageSize"
                      @update:currentPage="fetchPage"
                      @update:pageSize="fetchPageSize"
     />
   </ubi-panel>
 </ubi-page-container>
</template>
<script>
import UbiPageContainer from '@/components/PageContainer.vue'
import moment from 'moment/moment'
import UbiPanel from '@/components/Panel.vue'
import UbiStatValue from '@/components/statistics/StatValue.vue'
import { convertDate } from '@/helpers/functions/convertDate'
import UbiIcon from '@/components/Icon.vue'
import downloadexcel from 'vue-json-excel'
import PaginationPage from '@/components/ui/PaginationPage.vue'
import ApiSearchForm from '@/components/search/ApiSearchForm.vue'
import { capitalizeFirstLetter } from '@/helpers/capitalized'

export default {
  name: 'ReportByPortal',
  inject: ['browserContext'],
  components: { ApiSearchForm, PaginationPage, downloadexcel, UbiIcon, UbiStatValue, UbiPanel, UbiPageContainer },
  data () {
    return {
      nomFichierExport: this.$t('portals.report.filenameExportDiffusion') + '.xls',
      currentPage: 1,
      pageSize: 10,
      businessDomain: 'immo',
      searchRoute: 'portals/report'
    }
  },
  computed: {
    isSubUser () {
      return this.$store.getters.isSubUser
    },
    getLoadingReportByPortal () {
      return this.$store.getters['reportByPortal/getLoadingReportByPortal']
    },
    getNbAnnoncesQuota () {
      return this.$store.getters['reportByPortal/getNbAnnoncesQuota']
    },
    getNbAnnoncesSelectionnees () {
      return this.$store.getters['reportByPortal/getNbAnnoncesSelectionnees']
    },
    getNbAnnoncesMax () {
      return this.$store.getters['reportByPortal/getNbAnnoncesMax']
    },
    getModeSelectionAutomatique () {
      return this.$store.getters['reportByPortal/getModeSelectionAutomatique']
    },
    getDateEnd () {
      return this.$store.getters['reportByPortal/getDateEnd']
    },
    getNbAnnoncesTraitees () {
      return this.$store.getters['reportByPortal/getNbAnnoncesTraitees']
    },
    getNbAnnoncesDiffusees () {
      return this.$store.getters['reportByPortal/getNbAnnoncesDiffusees']
    },
    getLogoDiffuseur () {
      return this.$store.getters['reportByPortal/getLogoDiffuseur']
    },
    getNomDiffuseur () {
      return this.$store.getters['reportByPortal/getNomDiffuseur']
    },
    getTotalReportPortal () {
      return this.$store.getters['reportByPortal/getTotalReportPortal']
    },
    getAnnoncesReportByPortal () {
      return this.$store.getters['reportByPortal/getAnnoncesReportByPortal']
    },
    currentAnnonces () {
      return Array.isArray(this.getAnnoncesReportByPortal) ? this.getAnnoncesReportByPortal : []
    },
    localFilters () {
      return this.$store.getters['reportByPortal/getFilters']
    },
    searchContext () {
      return {
        user: this.$store.state.app.user,
        sitimmoUser: this.$store.state.app.sitimmoUser
      }
    }
  },
  methods: {
    capitalizeFirstLetter,
    convertDate,
    formatDate (date) {
      if (!date || date === null) return ''
      const regex = /^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/
      return regex.test(date) ? date : '-'
    },
    fileName () {
      const date = moment().format('YYYY_MM_DD')
      this.nomFichierExport = this.$t('portals.report.filenameExportDiffusion') + '_' + date + '.xls'
    },
    async fetchPage (page) {
      const previousPage = this.localFilters.page
      this.currentPage = page
      this.$store.commit('reportByPortal/setFilters', { key: 'page', value: page })
      try {
        await this.$store.dispatch('reportByPortal/loadReportByPortal', { diffuseur: this.$route.params.portal })
      } catch (e) {
        this.currentPage = previousPage
        this.$store.commit('reportByPortal/setFilters', { key: 'page', value: previousPage })
      }
    },
    async fetchPageSize (size) {
      const previousPage = this.localFilters.page
      const previousSize = this.localFilters.perPage
      this.pageSize = size
      this.currentPage = 1
      this.$store.commit('reportByPortal/setFilters', { key: 'perPage', value: size })
      this.$store.commit('reportByPortal/setFilters', { key: 'page', value: 1 })
      try {
        await this.$store.dispatch('reportByPortal/loadReportByPortal', { diffuseur: this.$route.params.portal })
      } catch (e) {
        this.pageSize = previousSize
        this.currentPage = previousPage
        this.$store.commit('reportByPortal/setFilters', { key: 'perPage', value: previousSize })
        this.$store.commit('reportByPortal/setFilters', { key: 'page', value: previousPage })
      }
    },
    handleSearchFromApi (filters) {
      this.currentPage = 1
      this.$store.commit('reportByPortal/setFilters', { key: 'search', value: filters.search || '' })
      this.$store.commit('reportByPortal/setFilters', { key: 'page', value: 1 })
      this.$store.dispatch('reportByPortal/loadReportByPortal', { diffuseur: this.$route.params.portal })
    },
    handleResetFromApi () {
      this.currentPage = 1
      this.$store.commit('reportByPortal/resetFilter')
      this.$store.dispatch('reportByPortal/loadReportByPortal', { diffuseur: this.$route.params.portal })
    },
    async exporterDiffusionByPortal () {
      return this.$store.dispatch('reportByPortal/exporterDiffusionByPortal', {
        diffuseur: this.$route.params.portal
      })
    }
  },
  mounted () {
    // Aligner l'UI pagination sur le store (évite désync au retour sur la page)
    this.currentPage = this.localFilters.page || 1
    this.pageSize = this.localFilters.perPage || 10
    this.$store.dispatch('reportByPortal/loadReportByPortal', { diffuseur: this.$route.params.portal })
  }
}
</script>
